const lifehack1 = ($star, $nose) => {
	new TimelineMax().to($star, 7, {
		rotation: '360deg',
		paused: false,
		repeat: -1,
		ease: Linear.easeNone,
		clearProps: 'true',
	}).to($nose, 3, {
		yPercent: 150,
		paused: false,
		repeat: -1,
		rotationZ: -0.0001,
		ease: Linear.easeNone,
		yoyo: true,
		clearProps: 'true',
	}, 0.5);
};

export default lifehack1;
